import axios from "axios";
import { API_URL } from "../constants/config";

export const fetchAnalytics = async (accountId) => {
    try {
      let data = JSON.stringify({
        "account_id": accountId
      });

      let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${API_URL}ops/api/analytics`,
          headers: { 
              'Content-Type': 'application/json',
          },
          data : data
      };

      const response = await axios.request(config);
      return response?.data?.data;
    } catch (err) {
      console.log(err);
      return {};
    }
}